import { useState } from "react";
import Grid from '@mui/material/Grid';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../../../components/Dialog/DiaComp";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import ExplorerSection from "../GetGene/ExplorerSection"
import Tooltip from '@mui/material/Tooltip';

export default function DiaVariants() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
    <Grid container>

        <Stack direction="column">
        <Typography variant="h5" sx={{fontWeight: '300'}}>Search variants on your genes:</Typography>
        
        <Tooltip title="Gene Explorer" placement="bottom">
            <IconButton onClick={handleOpen} aria-label="add an alarm">
                <TravelExploreIcon fontSize="large" />
            </IconButton>   
        </Tooltip>
        </Stack>
    </Grid>
    

    <CustomDialog open={open} onClose={handleClose}

         title="Gene Explorer - Insert gene of interest"
          
          content = {<ExplorerSection />}

        />
        
</>
)}